import { BaseAlgorithmTuner } from './BaseTuner';
import * as DT from '../DataTypes';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';

export class BooleanTuner extends BaseAlgorithmTuner<boolean, DT.BooleanT> {
  public constructor(planningAlgorithm: PlanningAlgorithm) {
    super(planningAlgorithm, DT.BooleanT);
  }
}
